<div class="container-fluid py-2 py-md-3 px-0">
  <div class="mb-4">
    <h1 class="mb-1">Amministrazione</h1>
    <p class="text-muted mb-0">
      Gestisci utenti, organizzazioni, eventi, tavoli e giochi: modifica ed eliminazione avvengono
      direttamente in questa pagina.
    </p>
  </div>

  <div ngbAccordion [closeOthers]="true" [animation]="false" [destroyOnHide]="false">
    <section ngbAccordionItem [collapsed]="false">
      <h2 ngbAccordionHeader class="accordion-header">
        <button ngbAccordionButton type="button">
          <i class="bi bi-people me-2"></i>Utenti
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            @if (users().length > 0) {
            <app-paginated-list [items]="users()" [pageSize]="6" colClass="col-12 col-md-4">
              <ng-template let-user>
                <div class="card h-100 w-100 flex-grow-1" data-cy="admin-user-item">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
                      <h5 class="card-title mb-0 text-truncate" [title]="user.userName">{{ user.userName }}</h5>
                      <div class="flex-shrink-0">
                        @if (user.userStatus?.banned) {
                        <span class="badge bg-danger" data-cy="admin-user-status-badge">Bannato</span>
                        } @else if (user.userStatus?.active) {
                        <span class="badge bg-success" data-cy="admin-user-status-badge">Attivo</span>
                        } @else if (user.userStatus?.emailVerificationPending) {
                        <span class="badge bg-warning text-dark" data-cy="admin-user-status-badge">In attesa mail</span>
                        } @else {
                        <span class="badge bg-secondary" data-cy="admin-user-status-badge">Disattivato</span>
                        }
                      </div>
                    </div>
                    <p class="card-text text-muted small mb-0">{{ user.email }} · {{ user.userType }}</p>
                  </div>
                  <div class="card-footer d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-outline-primary btn-sm" data-cy="admin-edit-user"
                      (click)="onEditUser(user)"><i class="bi bi-pencil me-1"></i>Modifica</button>
                    @if (user.id !== currentUserId && user.userType !== 'ADMINISTRATOR') {
                    @if (!user.userStatus?.active) {
                    <button type="button" class="btn btn-outline-success btn-sm" data-cy="admin-toggle-active-user"
                      (click)="onToggleUserActivation(user, true)">
                      <i class="bi bi-check-circle me-1"></i>{{ user.userStatus?.emailVerificationPending ? 'Forza attivazione' : 'Attiva' }}
                    </button>
                    } @else {
                    <button type="button" class="btn btn-outline-warning btn-sm" data-cy="admin-toggle-active-user"
                      (click)="onToggleUserActivation(user, false)">
                      <i class="bi bi-slash-circle me-1"></i>Disattiva
                    </button>
                    }
                    <button type="button" class="btn btn-outline-danger btn-sm" data-cy="admin-delete-user"
                      (click)="onDeleteUser(user)"><i class="bi bi-trash me-1"></i>Elimina</button>
                    }
                  </div>
                </div>
              </ng-template>
            </app-paginated-list>
            } @else {
            <p class="text-muted mb-0">Nessun utente trovato.</p>
            }
          </ng-template>
        </div>
      </div>
    </section>

    <section ngbAccordionItem>
      <h2 ngbAccordionHeader class="accordion-header">
        <button ngbAccordionButton type="button">
          <i class="bi bi-geo-alt me-2"></i>Luoghi
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            @if (locations().length > 0) {
            <app-paginated-list [items]="locations()" [pageSize]="6" colClass="col-12 col-md-4">
              <ng-template let-location>
                <div class="card h-100 w-100 flex-grow-1" data-cy="admin-location-item">
                  <div class="card-body">
                    <h5 class="card-title mb-1 text-truncate" [title]="location.formalName || location.address">
                      {{ location.formalName || location.address }}
                    </h5>
                    <p class="card-text text-muted small mb-0 text-truncate" [title]="location.address">
                      {{ location.address }}
                    </p>
                  </div>
                  <div class="card-footer d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-outline-primary btn-sm" data-cy="admin-edit-location"
                      (click)="onEditLocation(location)"><i class="bi bi-pencil me-1"></i>Modifica</button>
                    <button type="button" class="btn btn-outline-danger btn-sm" data-cy="admin-delete-location"
                      (click)="onDeleteLocation(location)"><i class="bi bi-trash me-1"></i>Elimina</button>
                  </div>
                </div>
              </ng-template>
            </app-paginated-list>
            } @else {
            <p class="text-muted mb-0">Nessun luogo trovato.</p>
            }
          </ng-template>
        </div>
      </div>
    </section>

    <section ngbAccordionItem>
      <h2 ngbAccordionHeader class="accordion-header">
        <button ngbAccordionButton type="button">
          <i class="bi bi-building me-2"></i>Organizzazioni
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="d-flex flex-wrap gap-2 mb-3">
              <a class="btn btn-outline-secondary btn-sm" routerLink="/organizations">
                <i class="bi bi-grid me-1" aria-hidden="true"></i>Catalogo
              </a>
              <a class="btn btn-outline-secondary btn-sm" routerLink="/organizations/manage">
                <i class="bi bi-gear me-1" aria-hidden="true"></i>Gestione
              </a>
              <a class="btn btn-primary btn-sm" routerLink="/organizations/add">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Organizzazione
              </a>
            </div>
            @if (organizations().length > 0) {
            <app-paginated-list [items]="organizations()" [pageSize]="6" colClass="col-12 col-md-4">
              <ng-template let-organization>
                <div class="card h-100 w-100 flex-grow-1" data-cy="admin-organization-item">
                  <div class="card-body">
                    <h5 class="card-title mb-1">{{ organization.organizationName }}</h5>
                    <p class="card-text text-muted small mb-0">
                      {{ organization.organizationActive ? 'Attiva' : 'Inattiva' }}
                      @if (organization.organizationEmail) { · {{ organization.organizationEmail }} }
                    </p>
                  </div>
                  <div class="card-footer d-flex flex-wrap gap-2">
                    <a class="btn btn-outline-info btn-sm" [routerLink]="['/organizations/detail', organization.id]"><i
                        class="bi bi-eye me-1"></i>Dettaglio</a>
                    <button type="button" class="btn btn-outline-primary btn-sm" data-cy="admin-edit-organization"
                      (click)="onEditOrganization(organization)"><i class="bi bi-pencil me-1"></i>Modifica</button>
                    <button type="button" class="btn btn-outline-danger btn-sm" data-cy="admin-delete-organization"
                      (click)="onDeleteOrganization(organization)"><i class="bi bi-trash me-1"></i>Elimina</button>
                  </div>
                </div>
              </ng-template>
            </app-paginated-list>
            } @else {
            <p class="text-muted mb-0">Nessuna organizzazione trovata.</p>
            }
          </ng-template>
        </div>
      </div>
    </section>

    <section ngbAccordionItem>
      <h2 ngbAccordionHeader class="accordion-header">
        <button ngbAccordionButton type="button">
          <i class="bi bi-calendar-event me-2"></i>Eventi
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="d-flex flex-wrap gap-2 mb-3">
              <a class="btn btn-outline-secondary btn-sm" routerLink="/events">
                <i class="bi bi-calendar-event me-1" aria-hidden="true"></i>Tutti gli eventi
              </a>
              <a class="btn btn-primary btn-sm" routerLink="/events/add">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Evento
              </a>
            </div>
            @if (events().length > 0) {
            <app-paginated-list [items]="events()" [pageSize]="6" colClass="col-12 col-md-4">
              <ng-template let-event>
                <div class="card h-100 w-100 flex-grow-1" data-cy="admin-event-item">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
                      <h5 class="card-title mb-0 text-truncate" [title]="event.name">{{ event.name }}</h5>
                      <div class="flex-shrink-0">
                        @if (event.active) {
                        <span class="badge bg-success" data-cy="admin-event-status-badge">Attivo</span>
                        } @else {
                        <span class="badge bg-secondary" data-cy="admin-event-status-badge">Disattivato</span>
                        }
                      </div>
                    </div>
                    <p class="card-text text-muted small mb-0">
                      {{ event.startDate | italianDate: 'dd/MM/yyyy' }}
                      @if (event.organization?.organizationName) { · {{ event.organization?.organizationName }} }
                    </p>
                  </div>
                  <div class="card-footer d-flex flex-wrap gap-2">
                    <a class="btn btn-outline-info btn-sm" [routerLink]="['/events/detail', event.id]"><i
                        class="bi bi-eye me-1"></i>Dettaglio</a>
                    <button type="button" class="btn btn-outline-primary btn-sm" data-cy="admin-edit-event"
                      (click)="onEditEvent(event)"><i class="bi bi-pencil me-1"></i>Modifica</button>
                    @if (!event.active) {
                    <button type="button" class="btn btn-outline-success btn-sm" data-cy="admin-toggle-active-event"
                      (click)="onToggleEventActivation(event, true)">
                      <i class="bi bi-check-circle me-1"></i>Attiva
                    </button>
                    } @else {
                    <button type="button" class="btn btn-outline-warning btn-sm" data-cy="admin-toggle-active-event"
                      (click)="onToggleEventActivation(event, false)">
                      <i class="bi bi-slash-circle me-1"></i>Disattiva
                    </button>
                    }
                    <button type="button" class="btn btn-outline-danger btn-sm" data-cy="admin-delete-event"
                      (click)="onDeleteEvent(event)"><i class="bi bi-trash me-1"></i>Elimina</button>
                  </div>
                </div>
              </ng-template>
            </app-paginated-list>
            } @else {
            <p class="text-muted mb-0">Nessun evento trovato.</p>
            }
          </ng-template>
        </div>
      </div>
    </section>

    <section ngbAccordionItem>
      <h2 ngbAccordionHeader class="accordion-header">
        <button ngbAccordionButton type="button">
          <i class="bi bi-table me-2"></i>Tavoli
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="d-flex flex-wrap gap-2 mb-3">
              <a class="btn btn-outline-secondary btn-sm" routerLink="/tables">
                <i class="bi bi-table me-1" aria-hidden="true"></i>Tutti i tavoli
              </a>
              <a class="btn btn-primary btn-sm" routerLink="/tables/add">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Tavolo
              </a>
            </div>
            @if (tables().length > 0) {
            <app-paginated-list [items]="tables()" [pageSize]="6" colClass="col-12 col-md-4">
              <ng-template let-table>
                <div class="card h-100 w-100 flex-grow-1" data-cy="admin-table-item">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
                      <h5 class="card-title mb-0 text-truncate" [title]="table.tableName">{{ table.tableName }}</h5>
                      <div class="flex-shrink-0">
                        @if (table.isActive) {
                        <span class="badge bg-success" data-cy="admin-table-status-badge">Attivo</span>
                        } @else {
                        <span class="badge bg-secondary" data-cy="admin-table-status-badge">Disattivato</span>
                        }
                      </div>
                    </div>
                    <p class="card-text text-muted small mb-0">
                      {{ table.playedGame?.gameName }}
                      @if (table.event?.name) { · {{ table.event?.name }} }
                    </p>
                  </div>
                  <div class="card-footer d-flex flex-wrap gap-2">
                    <a class="btn btn-outline-info btn-sm" [routerLink]="['/tables/detail', table.id]"><i
                        class="bi bi-eye me-1"></i>Dettaglio</a>
                    <button type="button" class="btn btn-outline-primary btn-sm" data-cy="admin-edit-table"
                      (click)="onEditTable(table)"><i class="bi bi-pencil me-1"></i>Modifica</button>
                    @if (!table.isActive) {
                    <button type="button" class="btn btn-outline-success btn-sm" data-cy="admin-toggle-active-table"
                      (click)="onToggleTableActivation(table, true)">
                      <i class="bi bi-check-circle me-1"></i>Attiva
                    </button>
                    } @else {
                    <button type="button" class="btn btn-outline-warning btn-sm" data-cy="admin-toggle-active-table"
                      (click)="onToggleTableActivation(table, false)">
                      <i class="bi bi-slash-circle me-1"></i>Disattiva
                    </button>
                    }
                    <button type="button" class="btn btn-outline-danger btn-sm" data-cy="admin-delete-table"
                      (click)="onDeleteTable(table)"><i class="bi bi-trash me-1"></i>Elimina</button>
                  </div>
                </div>
              </ng-template>
            </app-paginated-list>
            } @else {
            <p class="text-muted mb-0">Nessun tavolo trovato.</p>
            }
          </ng-template>
        </div>
      </div>
    </section>

    <section ngbAccordionItem>
      <h2 ngbAccordionHeader class="accordion-header">
        <button ngbAccordionButton type="button">
          <i class="bi bi-controller me-2"></i>Giochi
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="d-flex flex-wrap gap-2 mb-3">
              <a class="btn btn-outline-secondary btn-sm" routerLink="/games">
                <i class="bi bi-controller me-1" aria-hidden="true"></i>Tutti i giochi
              </a>
              <a class="btn btn-primary btn-sm" routerLink="/games/add">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Gioco
              </a>
            </div>
            @if (games().length > 0) {
            <app-paginated-list [items]="games()" [pageSize]="6" colClass="col-12 col-md-4">
              <ng-template let-game>
                <app-game-card [game]="game" (editGame)="onEditGame($event)" (deleteGame)="onDeleteGame($event)">
                </app-game-card>
              </ng-template>
            </app-paginated-list>
            } @else {
            <p class="text-muted mb-0">Nessun gioco trovato.</p>
            }
          </ng-template>
        </div>
      </div>
    </section>

    <section ngbAccordionItem>
      <h2 ngbAccordionHeader class="accordion-header">
        <button ngbAccordionButton type="button">
          <i class="bi bi-link-45deg me-2"></i>Giochi da ricongiungere
          @if (unlinkedGames().length > 0) {
            <span class="badge bg-warning text-dark ms-2">{{ unlinkedGames().length }}</span>
          }
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="text-muted small mb-3">
              Elenco dei giochi aggiunti manualmente privi di ID BoardGameGeek o RPGGeek.
              Puoi ricongiungerli mantenendo l'ID e i vincoli di integrità referenziali dei tavoli associati.
            </p>
            @if (unlinkedGames().length > 0) {
            <app-paginated-list [items]="unlinkedGames()" [pageSize]="6" colClass="col-12 col-md-4">
              <ng-template let-game>
                <div class="card h-100 w-100 flex-grow-1" data-cy="admin-unlinked-game-item">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
                      <h5 class="card-title mb-0 text-truncate" [title]="game.gameName">{{ game.gameName }}</h5>
                      <span class="badge bg-secondary">Creato a mano</span>
                    </div>
                    <p class="card-text text-muted small mb-0">
                      Tipo: {{ game.gameType }} · Giocatori: {{ game.minPlayers }}-{{ game.maxPlayers }}
                      @if (game.creatorName) { · Creato da: {{ game.creatorName }} }
                    </p>
                  </div>
                  <div class="card-footer d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-outline-primary btn-sm" data-cy="admin-relink-game"
                      (click)="onEditGame(game)"><i class="bi bi-link-45deg me-1"></i>Ricongiungi BGG/RPG</button>
                    <button type="button" class="btn btn-outline-danger btn-sm" data-cy="admin-delete-game"
                      (click)="onDeleteGame(game)"><i class="bi bi-trash me-1"></i>Elimina</button>
                  </div>
                </div>
              </ng-template>
            </app-paginated-list>
            } @else {
            <p class="text-muted mb-0">Nessun gioco da ricongiungere. Tutti i giochi sono collegati a BGG/RPGGeek.</p>
            }
          </ng-template>
        </div>
      </div>
    </section>
  </div>
</div>
